import { StaticBaseDao } from '@/dao';
import { MailRequest } from '@/objects/generated';

export class CommunicationDao extends StaticBaseDao {
    public static async ReportError(request: MailRequest, eventId?: number | null): Promise<void | null> {
        return this.Post(`Communication/ReportError` + '?' + (eventId == undefined ? '' : `eventId=${eventId}`), request);
    }
}
